import { ExplanationDocRevisionAgreementForm } from '../types'

export const isAgreementDocRevSigning = (
  docRev: ExplanationDocRevisionAgreementForm,
) => {
  const isRejected = docRev.signHistories.some(h => h.isRejected)
  return !!docRev.dsEnvelopeId && !docRev.isCompleted && !isRejected
}
